<template>
    <div class="flex">
        <tabs
            :active-key="tabs.indexOf(tabs.find(tab => tab.component === selectedComponent))"
            card
            :items="tabs"
            @set-active="setTab"
        />
    </div>
</template>

<script>
import {mapState, mapActions} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import {useCompaniesStore} from '../state/modules/companies';
import {useMultiPostingStore} from '../state/modules/multiPosting';
import Tabs from "./navigation/Tabs.vue"

export default {
    name: 'MultiPostingTabs',
    components: {Tabs},
    data() {
        return {
            tabs: [
                {
                    title: this.$t('multi-posting.tabs.campaigns.label'),
                    component: 'Campaigns',
                },
                {
                    title: this.$t('multi-posting.tabs.job-boards.label'),
                    component: 'JobBoards',
                },
                {
                    title: this.$t('multi-posting.tabs.social-boosts.label'),
                    component: 'SocialBoosts',
                },
                {
                    title: this.$t('multi-posting.tabs.contracts.label'),
                    component: 'Contracts',
                },
            ]
        }
    },
    computed: {
        ...mapState(useMultiPostingStore, ['selectedComponent']),
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['setSelectedComponent']),
        ...mapActions(useCompaniesStore, ['hasFeature']),
        setTab(index) {
            const tab = this.tabs[index];
            this.setSelectedComponent(tab.component);
        },
		checkAccess() {
            if (!this.hasFeature('multiposting')) {
                this.$router.push('/dashboard')
            }
        },
    },
    mounted() {
        this.checkAccess();
    }
}
</script>
